<template>
  <div>
    <h6 class="text-two">
      {{ question.semiology_form_question_type_description }}
    </h6>
    <div
      class="form-check"
      v-for="(item, key) in question.alternatives"
      :key="key"
    >
      <input
        class="form-check-input"
        type="checkbox"
        :id="`multiple-choice-${item.id}`"
        :data-id="item.id"
        @input="emit"
      />
      <label class="form-check-label" :for="`multiple-choice-${item.id}`">
        {{ item.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    category_id: [Number, String],
  },
  data() {
    return {
      question: {},
      answer: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    retrieve() {
      let { question } = this.$attrs;

      this.question = question;

      let answer = [];

      question.alternatives.map((item) =>
        answer.push({
          id: item.id,
          checked: false,
        })
      );

      this.answer = answer;
    },
    emit(e) {
      let { answer } = this;

      for (let item of answer) {
        if (item.id == e.target.dataset.id) {
          item.checked = e.target.checked;
        }
      }

      this.$emit("answer", {
        category_id: this.category_id,
        id: this.question.id,
        answer,
      });
    },
  },
};
</script>
